<template>
  <div class="twoSystem">
    <Menu></Menu>
    <div id="twoSystem" style="margin-top: 80px;">
    	<div class="twoSystem-first-screen">
			<video src="../assets/img/twovideos.mp4" style="width: 100%;height: auto;"
			     :autoplay='autoplay' :loop='loop'>
			</video>
			<div class="twoSystem-first-screen-position">
				<div class="twoSystem-first-screen-fitst">
					两大体系	
				</div>
				<div class="twoSystem-first-screen-second">
					Two major systems
				</div>
				<div class="twoSystem-first-screen-third">
					在牛家经济开发区建设哈尔滨循环经济产业园区——
				</div>
				<div class="twoSystem-first-screen-third"> 
					国家“城市矿产”示范基地
				</div>
				<div class="twoSystem-first-screen-third">
					打造废弃物从产生源头到再生资源循环利用之间完整供应链
				</div>
			</div>
		</div>
		<div class="twoSystem-second-screen">
			<div class="twoSystem-second-screen-box">
				
			</div>
		</div>
		<div class="twoSystem-third-screen">
			<div class="twoSystem-third-screen-box">
				<div class="twoSystem-third-screen-english">Standardized management of comprehensive services</div>
				<div class="twoSystem-third-screen-chinese">综合服务规范管理体系</div>
				<div class="twoSystem-third-screen-text">规范再生资源从业人员</div>
				<div class="twoSystem-third-screen-text">通过吸收、联合、规范等形式对流动收购人员进行人性化、规范化、常态化管理。</div>
				<div class="twoSystem-third-screen-content">
					<div class="twoSystem-third-img-box">
						<div class="twoSystem-third-img">
							<img src="../assets/img/ren.png" alt="" />
							<div>人性化</div>
						</div>
					</div>
					<div class="twoSystem-third-img-box">
						<div class="twoSystem-third-img">
							<img src="../assets/img/hua.png" alt="" />
							<div>规范化</div>
						</div>
					</div>
					<div class="twoSystem-third-img-box">
						<div class="twoSystem-third-img">
							<img src="../assets/img/chang.png" alt="" />
							<div>常态化</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="twoSystem-fouth-screen">
			<div class="twoSystem-fouth-screen-box">
				<div class="twoSystem-fouth-screen-right mbStyle">
					<div class="fouth-screen-one">Trading Platform for renewable resources</div>
					<div class="fouth-screen-two">建立<span class="fouth-screen-five">再生资源</span></div>
					<div class="fouth-screen-two">电子商务交易平台</div>
				</div>
				<div class="twoSystem-fouth-screen-left">
					<div class="twoSystem-fouth-moblie">
						<img src="../assets/img/moblie.png" alt="" />
					</div>
				</div>
				<div class="twoSystem-fouth-screen-right">
					<div class="fouth-screen-one pcStyle">Trading Platform for renewable resources</div>
					<div class="fouth-screen-two pcStyle">建立<span class="fouth-screen-five">再生资源</span></div>
					<div class="fouth-screen-two pcStyle">电子商务交易平台</div>
					<div class="fouth-screen-four" style="margin-top: 80px;">运用手机 APP、微信公众号、400 服务电话呼叫上门回收，现场对可回收物进行称重、扫码、确认信息后居民可兑换商品，可选择收取现金等方式对可回收物进行交易，鼓励居民参与垃圾分类。实现网上预约、上门回收，推动线上线下协同发展。</div>
					<div class="fouth-screen-five fouth-screen-three">运用互联网、物联网、大数据和云计算等现代信息技术，构建全链条业务信息平台和回收追溯系统。</div>
					<div class="fouth-screen-four">回收完成后，统一运送到小区生活垃圾分类回收便民服务站，运用专业运输车辆、GPS 定位系统统一管理，进行分类运输，将再生资源及大件垃圾统一运往哈尔滨循环经济产业园区—国家“城市矿产”示范基地进行规模化、规范化、清洁化生产，<span class="fouth-screen-five">实现再生资源回收与生活垃圾分类“两网融合”，实现回收、加工、利用一体化管理。</span></div>
				</div>
			</div>
		</div>
    </div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'twoSystem',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		autoplay:true,
		loop:true
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/twoSystem.scss';

</style>


// WEBPACK FOOTER //
// src/components/twoSystem.vue